<template>
    <v-select
            label="Gender"
            :items="[{text: 'Male',value: api.CONSTANTS.GENDER.MALE},{text: 'Female',value: api.CONSTANTS.GENDER.FEMALE}]"
            v-model="value"
            :rules="rules"
            append-icon="fa fa-venus-mars"
    />
</template>

<script>
    export default {
        props: ['value', 'label', 'rules'],
        name: "choose-gender",
        mounted() {
            if (this.value === undefined)
                this.$emit('input', this.api.CONSTANTS.GENDER.MALE);
        },
        watch: {
            value(val) {
                this.$emit('input', val);
            }
        }
    }
</script>

<style scoped>

</style>